import { render, staticRenderFns } from "./CreateWork.vue?vue&type=template&id=3cb81d58&"
import script from "./CreateWork.vue?vue&type=script&lang=js&"
export * from "./CreateWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports